// extracted by mini-css-extract-plugin
export var cases__slider = "cases-module--cases__slider---ncl6";
export var cases__sliderContainer = "cases-module--cases__sliderContainer--bnpyn";
export var cases__sliderTitle = "cases-module--cases__sliderTitle--HAyQj";
export var cases__card = "cases-module--cases__card--ovBdA";
export var cases__cardValue = "cases-module--cases__cardValue--QPL9c";
export var cases__cardValueDesc = "cases-module--cases__cardValueDesc--BS5in";
export var cases__cardSeparator = "cases-module--cases__cardSeparator--6Z8ER";
export var cases__cardDesc = "cases-module--cases__cardDesc--dpBZT";
export var cases__cardLogoWrapper = "cases-module--cases__cardLogoWrapper--K0a9W";
export var cases__linkContainer = "cases-module--cases__linkContainer--ExT8g";